import React from 'react';
import './AiSelectorBar.css';

const AI_MODELS = [
  { id: 'deepseek', name: 'DeepSeek 4.5', active: true, logo: '/assets_new/img/deepseek-logo.svg' },
  { id: 'gemini', name: 'Gemini 3 Pro', active: false, logo: null },
  { id: 'claude', name: 'Claude 3.7', active: false, logo: null },
  { id: 'gpt5', name: 'GPT-5', active: false, logo: null },
  { id: 'grok', name: 'Grok 2', active: false, logo: null },
];

function AiSelectorBar() {
  return (
    <div className="ai-selector-bar">
      {AI_MODELS.map((model) => (
        <div
          key={model.id}
          className={`ai-selector-btn ${model.active ? 'active' : 'disabled'}`}
        >
          <span className={`ai-selector-dot ${model.active ? 'active' : ''}`} />
          {model.logo && (
            <img src={model.logo} alt={model.name} className="ai-selector-logo" />
          )}
          <span className="ai-selector-name">{model.name}</span>
          {!model.active && <span className="ai-selector-soon">SOON</span>}
        </div>
      ))}
    </div>
  );
}

export default AiSelectorBar;
